import { useQuery } from '@tanstack/react-query'
import AudioNoteIpcRenderer from '@renderer/ipc/AudioNoteIpc.renderer'
import { AudioNote } from '@highlight/common'

export const useAudioNote = (audioNoteId?: string) => {
  return useQuery({
    queryKey: ['audio-note', audioNoteId],
    queryFn: async () => {
      if (!audioNoteId) return null
      const result = await AudioNoteIpcRenderer.getAudioNote(audioNoteId)
      return result as AudioNote
    },
    enabled: !!audioNoteId,
  })
}
